import React from 'react';
import { useToasts, Dialog, Text, Select, Button, Flex } from '@applyboard/crystal-ui';
import { useBulkPatchIntakes } from '../data/useBulkPatchIntakes';
import { useSelectedIntakes } from '~/context/SelectedIntakesContext';

export function BulkChangeStatusModal() {
  const toast = useToasts();
  const { selectedIntakes, clear } = useSelectedIntakes();
  const [isOpen, setIsOpen] = React.useState(false);
  const { pathIntakes, isPatchingIntakes } = useBulkPatchIntakes(selectedIntakes);
  const [selectedStatus, setSelectedStatus] = React.useState<'open' | 'close' | ''>('');

  async function applyChanges() {
    if (!selectedStatus) return;
    await pathIntakes(selectedStatus)
      .then(() => {
        toast.positive('All selected intakes are updated with new status');
        setIsOpen(false);
        clear();
      })
      .catch((err) => toast.negative(new Error('Failed to update intakes', { cause: err })))
      .finally(() => setSelectedStatus(''));
  }

  return (
    <Dialog open={isOpen} onOpenChange={(v) => setIsOpen(v)} size="md">
      <Dialog.Trigger>
        <Button variant="outlined" onClick={() => setIsOpen(true)}>
          Change Status
        </Button>
      </Dialog.Trigger>
      <Dialog.Heading>Change intake status</Dialog.Heading>
      <Dialog.Content>
        <Flex gap={4} direction="column">
          <Text variant="bodyM">Please select intake status</Text>
          <Select
            label="Intake Status"
            required
            onChange={(value) => setSelectedStatus(value as 'open' | 'close')}
            appearance="styled"
            value={selectedStatus}
          >
            <Select.Option label="Open" value="open" />
            <Select.Option label="Close" value="close" />
          </Select>
        </Flex>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill" intent="secondary" disabled={isPatchingIntakes}>
          Cancel
        </Dialog.CloseButton>
        <Button
          width="fill"
          intent="primary"
          emphasis="contained"
          onClick={() => applyChanges()}
          disabled={!selectedStatus}
          loading={isPatchingIntakes}
        >
          Confirm
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
}
